import type { SelectHTMLAttributes, ReactNode } from 'react';
import { LuChevronDown } from 'react-icons/lu';
import { select, selectWrap, selectChevron } from './Field.css';

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className'> {
  children: ReactNode;
}

export function Select({ children, ...rest }: SelectProps) {
  return (
    <span className={selectWrap}>
      <select className={select} {...rest}>{children}</select>
      <LuChevronDown size={16} className={selectChevron} aria-hidden />
    </span>
  );
}
